export enum DataLayerEvent {
	// Insurance
	UnverifiedInsurance = 'new_patient_forms_insurance_sent_to_ivq',
	ScannedInsuranceSubmission = 'new_patient_forms_scans_insurance_card',
	NoInsuranceSubmission = 'new_patient_forms_continues_without_insurance',
	VerifiedInsurance = 'new_patient_forms_insurance_is_verified_on_continue',
	InsurancePrimaryAccountHolder = 'new_patient_forms_is_primary_account_holder',
	ManualInsuranceSubmission = 'new_patient_forms_patient_inputs_insurance_details_manually',
	CombinationInsuranceSubmission = 'new_patient_forms_insurance_information_inputs_combined',

	// Address
	AddressSuggestion = 'address_suggestion_updated',
	AccountInformationAddress = 'click_save_account_information_page',

	//Language
	LanguageSelected = 'language_selected',

	// Generic
	ClickEvent = 'click_event',
	NavigationClick = 'navigation_click_event',
	PageView = 'page_view',
}

export enum DataLayerUserAction {
	PageView = 'page-view',
	Click = 'click',
	Scroll = 'scroll',
	ElementView = 'element-view',
	Type = 'type',
}
